import {request} from '@/helpers/apiClient'
import {UPLOAD_IMAGES_CONFIG} from '@/utils/constants/apiConfig/uploadImagesConfig'

export const uploadProductMediaService = ({productId, formData, onUploadProgress}) => {
  return request(UPLOAD_IMAGES_CONFIG.UPLOAD_PRODUCT_MEDIA(productId), {
    formData,
    onUploadProgress,
  })
}

export const deleteProductMediaService = ({productId, displayOrder}) => {
  return request(UPLOAD_IMAGES_CONFIG.DELETE_PRODUCT_MEDIA(productId, displayOrder))
}
